import EmailAuthLink from './EmailAuthLink';

export default EmailAuthLink;
